module.exports = __webpack_public_path__ + "static/img/logo1.73ed5aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.jpg
// module id = Op7H
// module chunks = 2